import { render, staticRenderFns } from "./FbWebLink.vue?vue&type=template&id=2845972c"
import script from "./FbWebLink.vue?vue&type=script&lang=js"
export * from "./FbWebLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports